import * as interfaces from '../interfaces';
import { ApiService } from './api.service';
import { CookieService, TrackerServiceInstance } from 'services';

const { REACT_APP_DEPLOYMENT_ENV } = process.env;

export let UserServiceInstance: UserService | null = null;

export function createUserServiceInstance(): void {
  if (!UserServiceInstance)
    UserServiceInstance = new UserService();
}

export class UserService extends ApiService {
  private id: string;
  public defaultUser: interfaces.UserInterface | any
  static readonly GOOGLE_CLIENT_ID = '407876644839-jn5cvmstfbcdrvv3p4hksjogp9l9j86m.apps.googleusercontent.com';

  constructor() {
    super();

    this.defaultUser = {}

    this.id = 'UserService';
  }

  getUser(): Promise<interfaces.SessionDataInterface>{
    const errorIdentifier = `${this.id} -> Get User (current session)`;
    const locallyStoredUser = CookieService.getLocalStorage('user', true);

    const email =
      (locallyStoredUser ? locallyStoredUser : this.defaultUser).email || CookieService.getCookie('email');

    const token = CookieService.getLocalStorage('token') || CookieService.getCookie('token');

    this.updateRequestHeader('authorization', token);
    this.updateRequestHeader('email', email);

    return this.get({ endpoint: 'currentSession' })
      .then((res: any) => {
        const responseData: interfaces.SessionDataInterface = (res.data?.data || [])[0];

        if (!responseData) {
          this.reportInvalidResponseError(errorIdentifier, res);

          this.clearUserData();
        }
        this.defaultUser = responseData.user;

        return responseData;
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);
        this.clearUserData();
        return {} as interfaces.SessionDataInterface;
      });
  }

  getUserByEmail(clientId: string, enteredEmail : string): Promise<interfaces.SessionDataInterface> | any {
    const errorIdentifier = `${this.id} -> Get User by Email (current session)`;

    return this.post({endpoint: 'currentSession'}, {clientId: clientId, email: enteredEmail})
      .then((response: any) => {

        if (!response.data) {
          this.reportInvalidResponseError(errorIdentifier, response);
        }

        return response.data;
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return {} as any;
      });
  }

  getUserByMagicLink(magicToken: string): Promise<interfaces.SessionDataInterface> {
    const errorIdentifier = `${this.id} -> Get User by Magic Link (current session)`;

    return this.post({ endpoint: 'magicSession' }, { token: magicToken })
      .then((res: any) => {
        const responseData: interfaces.SessionDataInterface = (res.data?.data || [])[0];

        if (!responseData) {
          this.reportInvalidResponseError(errorIdentifier, res);

          this.clearUserData();
        }

        this.defaultUser = responseData.user;

        return responseData;
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return {} as interfaces.SessionDataInterface;
      });
  }

  sendMagicLink(email: string, clientId: string, voted: boolean = false) {
    const errorIdentifier = `${this.id} -> Send Magic Link`;

    return this.post({ endpoint: 'magic', path: `?voted=${voted}` }, { email, clientId }).catch(err => {
      this.reportRequestError(errorIdentifier, err);
      return {} as any;
    });
  }

  updateCurrentUserSession(data: {
    firstName?: string;
    lastName?: string;
    email?: string;
    clientId?: string;
    location?: string;
    ipa?: string;
    zip?: string;
  }): Promise<interfaces.SessionDataInterface> {
    const errorIdentifier = `${this.id} -> Update User (current session)`;

    return this.put({ endpoint: 'currentUser' }, data)
      .then((res: any) => {
        const responseData: interfaces.GeneralResponseInterface<interfaces.SessionDataInterface> = res.data;

        // TrackerServiceInstance?.trackEvent

        if (!responseData.data || !responseData.data.length)
          this.reportInvalidResponseError(errorIdentifier, res);

        return responseData.data[0];
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return {} as interfaces.SessionDataInterface;
      });
  }

  getIPA(): Promise<interfaces.UserIpaResponse> {
    const errorIdentifier = `${this.id} -> Get User IPA`;

    if (window.location.hostname === 'localhost') {
      return new Promise(resolve => {
        resolve({
          ip: '74.64.48.102',
          hostname: 'cpe-74-64-48-102.nyc.res.rr.com',
          city: "Hell's Kitchen",
          region: 'New York',
          country: 'US',
          loc: '40.7571,-73.9657',
          org: 'AS12271 Charter Communications Inc',
          postal: '10022',
          timezone: 'America/New_York'
        });
      });
    } else {
      return this.get({ fullURL: 'https://ipinfo.io/json', endpoint: 'empty' })
        .then((res: any) => {
          const responseData: interfaces.UserIpaResponse = res.data;

          if (!responseData)
            this.reportInvalidResponseError(errorIdentifier, res);

          return responseData;
        })
        .catch(err => {
          this.reportRequestError(errorIdentifier, err);

          return {} as interfaces.UserIpaResponse;
        });
    }
  }

  submitVolunteerForm(data: {
    selectedOptions: string;
    name: string;
    toEmail: string;
    email: string;
    phone: string;
    zip: string;
  }) {
    const errorIdentifier = `${this.id} -> Submit Volunteer Form`;

    return this.post({ endpoint: 'volunteer' }, data).catch(err => {
      this.reportRequestError(errorIdentifier, err);

      return {} as any;
    });
  }

  getLocalUserData() {
    return JSON.parse(localStorage?.user || '{}')
  }

  storeLocalUserData(user: interfaces.UserInterface) {
    return CookieService.setLocalStorage('user', user, true);
  }

  storeUserAndSessionData(user: interfaces.UserInterface, token: string): void {
    CookieService.setLocalStorage('token', token);
    CookieService.setLocalStorage('user', user, true);

    CookieService.setCookie('email', user.email as string);
    CookieService.setCookie('token', token);
  }


  clearUserData(): void {
    CookieService.removeLocalStorage('token');
    CookieService.removeLocalStorage('user');

    CookieService.eraseCookie('token');
    CookieService.eraseCookie('email');
  }
}
